export const CREATE_BULK_LABEL_SUCCESS = 'CREATE_BULK_LABEL_SUCCESS';
export const CREATE_BULK_LABEL_REQUEST = 'CREATE_BULK_LABEL_REQUEST';
export const CREATE_BULK_LABEL_FAILURE = 'CREATE_BULK_LABEL_FAILURE';
export const CREATE_BULK_LABEL_RESET = 'CREATE_BULK_LABEL_RESET';
export const createBulkLabelSuccess = (payload) => ({
    type: CREATE_BULK_LABEL_SUCCESS,
    payload,
});
export const createBulkLabelRequest = (payload) => ({
    type: CREATE_BULK_LABEL_REQUEST,
    payload,
});
export const createBulkLabelFailure = (payload) => ({
    type: CREATE_BULK_LABEL_FAILURE,
    payload,
});
export const createBulkLabelReset = () => ({
    type: CREATE_BULK_LABEL_RESET,
});
